import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '@/lib/supabase';

function getOrCreateSessionId(): string {
  const key = 'rdy_session_id';
  let sid = sessionStorage.getItem(key);
  if (!sid) {
    sid = `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
    sessionStorage.setItem(key, sid);
  }
  return sid;
}

export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    const track = async () => {
      try {
        await supabase.from('pageviews').insert({
          page: location.pathname + location.search,
          referrer: document.referrer || null,
          user_agent: navigator.userAgent,
          session_id: getOrCreateSessionId(),
        });
      } catch {
        // silently fail — never break the user experience
      }
    };
    track();
  }, [location.pathname, location.search]);
}
